import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { MapPin, Lightbulb, Calendar, ArrowRight } from "lucide-react";

const PartnershipFormats = () => {
  const formats = [
    {
      title: "Cohort / State Program Sponsorship",
      budget: "₹25L – ₹1.5 Cr",
      description: "Defined beneficiaries · Clear outcomes · State-level impact",
      icon: MapPin,
      color: "#1F7A5A"
    },
    {
      title: "Thematic Partnerships",
      budget: "Flexible",
      description: "Education · Employability · Livelihoods · Mental Health",
      icon: Lightbulb,
      color: "#4FB6A6"
    },
    {
      title: "Multi-Year Partnerships",
      budget: "₹1 Cr+",
      description: "Platform-level or national initiatives · Long-term impact",
      icon: Calendar,
      color: "#F4C430"
    }
  ];

  const handleLearnMore = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setTimeout(() => {
      const ctaBtn = document.querySelector('[data-testid="explore-csr-btn"]');
      if (ctaBtn) ctaBtn.click();
    }, 500);
  };

  return (
    <section id="partnership" className="py-12 md:py-16 bg-[#F8F9F7]" data-testid="partnership-formats-section">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="mb-10 text-center">
          <Badge className="mb-3 bg-[#1F7A5A]/10 text-[#1F7A5A] hover:bg-[#1F7A5A]/20 border-0 text-xs">
            Engagement Models
          </Badge>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-[#4A4A4A] mb-3">
            CSR Partnership Formats
          </h2>
          <p className="text-[#6B7280] max-w-xl mx-auto mb-2">
            Choose the model that aligns with your CSR objectives and budget
          </p>
          <p className="text-sm text-[#1F7A5A] font-medium">
            Flexible deployment across states, cohorts, and multi-year structures.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {formats.map((format, index) => (
            <Card 
              key={index}
              className="partnership-card group cursor-pointer p-6"
              data-testid={`partnership-card-${index}`}
              onClick={handleLearnMore}
            >
              <div 
                className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform"
                style={{ backgroundColor: format.color }}
              >
                <format.icon className="w-6 h-6 text-white" />
              </div>
              
              <h3 className="font-display text-lg font-bold text-[#4A4A4A] mb-2">
                {format.title}
              </h3>
              
              <div className="inline-block px-3 py-1 bg-[#F8F9F7] rounded-full mb-3">
                <span className="text-sm font-semibold text-[#1F7A5A]">{format.budget}</span>
              </div>
              
              <p className="text-[#6B7280] text-sm leading-relaxed">
                {format.description}
              </p>
              
              <div className="mt-4 pt-4 border-t border-[#E5E7EB]">
                <span className="text-[#1F7A5A] text-sm font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                  Learn more <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnershipFormats;
